import { render, staticRenderFns } from "./comp_OrderSummary-Totals.vue?vue&type=template&id=5fd06280&scoped=true&"
import script from "./comp_OrderSummary-Totals.vue?vue&type=script&lang=js&"
export * from "./comp_OrderSummary-Totals.vue?vue&type=script&lang=js&"
import style0 from "./comp_OrderSummary-Totals.vue?vue&type=style&index=0&id=5fd06280&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd06280",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VListItem,VSpacer})
